class TitleConstants {
  App = "Mailzzy";
  Separator = " | ";

  FormattedTitleEnd = this.Separator + this.App;

  LOGIN = "Login" + this.FormattedTitleEnd;
  FORGOT_PASSWORD = "Forgot Password" + this.FormattedTitleEnd;
  RESET_PASSWORD = "Reset Password" + this.FormattedTitleEnd;
  VERITY_OTP = "Verify OTP" + this.FormattedTitleEnd;
  SETUP_MFA = "Setup MFA" + this.FormattedTitleEnd;
  REGISTER = "Register" + this.FormattedTitleEnd;
  CHECK_YOUR_EMAIL = "Check your email" + this.FormattedTitleEnd;

  PROFILE = "Profile" + this.FormattedTitleEnd;
  EDIT_PROFILE = "Edit Profile" + this.FormattedTitleEnd;
  DOCUMENTS = "Documents" + this.FormattedTitleEnd;

  APPLICANTS = "Applicants" + this.FormattedTitleEnd;
  VIEW_APPLICANTS = "Applicant" + this.FormattedTitleEnd;
  ADD_APPLICANTS = "Add Applicant" + this.FormattedTitleEnd;
  EDIT_APPLICANTS = "Edit Applicant" + this.FormattedTitleEnd;

  JOBPOSTING = "Job Postings" + this.FormattedTitleEnd;
  VIEW_JOBPOSTING = "Job Posting" + this.FormattedTitleEnd;
  ADD_JOBPOSTING = "Add Job Posting" + this.FormattedTitleEnd;
  EDIT_JOBPOSTING = "Edit Job Posting" + this.FormattedTitleEnd;
  SUBMISSIONS_JOBPOSTING = "Submissions" + this.FormattedTitleEnd;
  APPLICANT_PROFILE_SUBMISSION =
    "Applicant Profile Submission" + this.FormattedTitleEnd;

  HEALTH_WORKERS = "Health Workers" + this.FormattedTitleEnd;
  VIEW_HEALTH_WORKERS = "Health Worker" + this.FormattedTitleEnd;
  ADD_HEALTH_WORKERS = "Add Health Worker" + this.FormattedTitleEnd;
  EDIT_HEALTH_WORKERS = "Edit Health Worker" + this.FormattedTitleEnd;
  ADD_CONTRACT = "Add Contract" + this.FormattedTitleEnd;

  CLIENT = "Clients" + this.FormattedTitleEnd;
  VIEW_CLIENT = "Client" + this.FormattedTitleEnd;
  ADD_CLIENT = "Add Client" + this.FormattedTitleEnd;
  EDIT_CLIENT = "Edit Client" + this.FormattedTitleEnd;

  FACILITIES = "Facilities" + this.FormattedTitleEnd;
  VIEW_FACILITY = "Facility" + this.FormattedTitleEnd;
  ADD_FACILITY = "Add Facility" + this.FormattedTitleEnd;
  EDIT_FACILITY = "Edit Facility" + this.FormattedTitleEnd;

  VENDORS = "Vendors" + this.FormattedTitleEnd;
  VIEW_VENDOR = "Vendor" + this.FormattedTitleEnd;
  ADD_VENDOR = "Add Vendor" + this.FormattedTitleEnd;
  EDIT_VENDOR = "Edit Vendor" + this.FormattedTitleEnd;

  MARGIN_CALCULATOR = "Margin Calculator" + this.FormattedTitleEnd;

  SETTING = "Settings" + this.FormattedTitleEnd;
  GENERAL = "General" + this.FormattedTitleEnd;
  USERS = "Users" + this.FormattedTitleEnd;
  DOMAINS = "Domains" + this.FormattedTitleEnd;
  ROLE_MANAGEMENT = "Role Management" + this.FormattedTitleEnd;
  SECURITY = "Security" + this.FormattedTitleEnd;
  PREFERENCES = "Preferences" + this.FormattedTitleEnd;
  ACCOUNT = "Account" + this.FormattedTitleEnd;
  LOCATION = "Location" + this.FormattedTitleEnd;

  TIMESHEET = "Timesheet" + this.FormattedTitleEnd;

  INVOICES = "Invoices" + this.FormattedTitleEnd;
  VIEW_INVOICES = "View Invoice" + this.FormattedTitleEnd;
  EDIT_INVOICES = "Edit Invoice" + this.FormattedTitleEnd;

  BILLS = "Bills" + this.FormattedTitleEnd;
  VIEW_BILL = "View Bill" + this.FormattedTitleEnd;
  ADD_BILL = "Add Bill" + this.FormattedTitleEnd;
  EDIT_BILL = "Edit Bill" + this.FormattedTitleEnd;

  EXPENSES = "Expenses" + this.FormattedTitleEnd;
  VIEW_EXPENSES = "View Expense" + this.FormattedTitleEnd;
  ADD_EXPENSES = "Add Expense" + this.FormattedTitleEnd;
  EDIT_EXPENSES = "Edit Expense" + this.FormattedTitleEnd;

  PRE_EXPENSES = "Onboard Expenses" + this.FormattedTitleEnd;
  VIEW_PRE_EXPENSES = "View Onboard Expense" + this.FormattedTitleEnd;
  ADD_PRE_EXPENSES = "Add Onboard Expense" + this.FormattedTitleEnd;
  EDIT_PRE_EXPENSES = "Edit Onboard Expense" + this.FormattedTitleEnd;

  DASHBOARD = "Dashboard" + this.FormattedTitleEnd;
  CONTACTS = "Contacts" + this.FormattedTitleEnd;
  IMPORT_CONTACTS = "Import Contacts" + this.FormattedTitleEnd;
  GROUPS = "Groups" + this.FormattedTitleEnd;
  TAGS = "Tags" + this.FormattedTitleEnd;
  TICKETS = "Tickets" + this.FormattedTitleEnd;
  COMPANIES = "Companies" + this.FormattedTitleEnd;
  EMAILS = "Emails" + this.FormattedTitleEnd;
  SOCIAL = "Social" + this.FormattedTitleEnd;
  TEMPLATES = "Templates" + this.FormattedTitleEnd;
  INTEGRATIONS = "Integrations" + this.FormattedTitleEnd;
  REPORTING = "Reporting" + this.FormattedTitleEnd;

  RECIPIENT_DOMAINS = "Recipient Domains" + this.FormattedTitleEnd;
  FAILED_STATS = "Failed Stats" + this.FormattedTitleEnd;

  INTEGRATION = "Integration" + this.FormattedTitleEnd;

  CAMPAIGNS = "Campaigns" + this.FormattedTitleEnd;
  STATS = "Stats" + this.FormattedTitleEnd;
  CREATE_REGULAR_CAMPAIGN = "Create Regular Campaign" + this.FormattedTitleEnd;
  CREATE_RESEND_CAMPAIGN = "Create Resend Campaign" + this.FormattedTitleEnd;
  CREATE_RETARGET_CAMPAIGN =
    "Create Retarget Campaign" + this.FormattedTitleEnd;
  CREATE_AB_TEST_CAMPAIGN = "Create AB Test Campaign" + this.FormattedTitleEnd;
  CREATE_SEQUENTIAL_CAMPAIGN =
    "Create Sequential Campaign" + this.FormattedTitleEnd;
  CREATE_SOCIAL_CAMPAIGN = "Create Social Campaign" + this.FormattedTitleEnd;

  addPrefixToTitle = (prefix: string, suffix: string) => {
    if (!prefix) {
      return suffix;
    }
    return prefix + this.Separator + suffix;
  };
}

let title = new TitleConstants();
export default title;
